module.exports = function (app) {
    app.controller("pages.account.webmd", ["$scope", "services","session", function ($scope,services,session) {
            //$scope.headings = "ACCOUNT SETTINGS";
            $scope.submitResultFlag = false;

        $scope.accountSettingsRetrieveFunction = function() {

            services.rbsmbl.AccountSettingsRetrive().retriveAccountSettings(session.data.groupNumber, "Y", session.data.memberInfo.brand, session.data.memberInfo.userName)
                .then(function (accountSettingsData) {

                    if (accountSettingsData && accountSettingsData.data && accountSettingsData.data.payload) {
                        $scope.accountRetrieveData = accountSettingsData.data.payload;
                        var acctData = accountSettingsData.data.payload;
                        console.log("25:acctData:::", acctData);
                        $scope.homePhone = acctData.homePhone;
                        $scope.workPhone = acctData.workPhone;
                        $scope.mobilePhone = acctData.mobilePhone;
                        $scope.emailAddress = acctData.emailAddress;

                        if($scope.accountRetrieveData.selectedSendClaimsToPersonalHealthRecord==="NY"){

                            document.getElementById("NY").checked = true;
                        }
                        else if($scope.accountRetrieveData.selectedSendClaimsToPersonalHealthRecord==="NO"){

                            document.getElementById("NO").checked = true;
                        }
                    }

                });
        };
        $scope.accountSettingsRetrieveFunction();

$scope.radiobuttonChange = function() {

    document.getElementById("wellnesssubmit").disabled = false;

        };
            $scope.submit = function () {

                document.getElementById("wellnesssubmit").disabled = true;
                $scope.submitResultFlag = true;

                var payload = {
                    "brand": session.data.memberInfo.brand,
                    "groupNumber":session.data.groupNumber,
                    "address1":$scope.accountRetrieveData.address1,
                    "address2":$scope.accountRetrieveData.address2,
                    "address3":$scope.accountRetrieveData.address3,
                    "address4":$scope.accountRetrieveData.address4,
                    "city":$scope.accountRetrieveData.city,
                    "state":$scope.accountRetrieveData.state,
                    "zip":$scope.accountRetrieveData.zip,
                    "mobilePhone": "4120000015",
                    "selectedSendClaimsToPersonalHealthRecord":document.querySelector('input[name="rate"]:checked').value,
                    "intakeRequest":{
                        "bdUserId":session.data.memberInfo.bvUserId,
                        "contactFirstName":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].contact.firstName,
                        "contactLastName":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].contact.lastName,
                        "memberFirstName":session.data.memberInfo.firstName,
                        "memberLastName":session.data.memberInfo.lastName,
                        "birthDate":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].contact.birthDate,
                        "gender":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].gender,
                        "relationshipCode":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].relationshipCode,
                        "enrollmentSourceCode":session.data.memberInfo.clientList[0].enrollmentSourceCode,
                        "ecId":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].ecId,
                        "umi":session.data.memberInfo.umi,
                        "lob":session.data.memberInfo.clientList[0].groupList[0].productList[0].lob,
                        "alphaPrefix":session.data.memberInfo.clientList[0].groupList[0].productList[0].alphaPrefix,
                        "groupNumber":session.data.memberInfo.clientList[0].groupList[0].groupNumber,
                        "benefitPlanName":session.data.memberInfo.clientList[0].groupList[0].productList[0].benefitPlanName,
                        "coverageBeginDate":session.data.memberInfo.clientList[0].groupList[0].productList[0].coverageBeginDate,
                        "coverageEndDate":session.data.memberInfo.clientList[0].groupList[0].productList[0].coverageEndDate,
                        "agreementId":session.data.memberInfo.agreementId,
                        "clientName":session.data.memberInfo.clientList[0].clientName,
                        "clientId":session.data.memberInfo.clientList[0].clientId,
                        "coveredIndividualId":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].coveredIndividualId,
                        "internalGroupNumber":session.data.memberInfo.clientList[0].groupList[0].internalGroupNumber
                    },
                    "homePhone":"4120000013",
                    "workPhone":"4120000014"
                };

                services.rbsmbl.AccountSettingsRetrive()
                    .saveAccountSettings(payload, "ccsAccountSettings", session.data.memberInfo.brand, session.data.memberInfo.userName)
                    .then(function(accountSettingsDataResponse) {
                        $scope.accountSettingsRetrieveFunction();
                    });
            };

    }]);
};